module.exports = __webpack_public_path__ + "static/media/vip-message-icon.3ac47842.png";